import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Blog from '../components/Blog';
import Certification from '../components/Certification';
import Hero from '../components/Hero';
import InstaGram from '../components/InstaGram';
import Loan from '../components/Loan';
// import Location from '../components/Location';
import Press from '../components/Press';
import Process from '../components/Process';
import Promotions from '../components/Promotions';
// import Questionnaire from '../components/Questionnaire';
import RecentlyAdded from '../components/RecentlyAdded';
import SearchByCategory from '../components/SearchByCategory';
import Service from '../components/Service';
import Layout from '../layout/Layout';

import CarListByType from '../components/CarListByType';
import ChooseAuto24 from '../components/ChooseAuto24';
import FooterContent from '../components/FooterContent';
import DownloadApp from '../components/ui/DownloadApp';
import FilteredCarModelsFooter from '../components/ui/FilteredCarModelsFooter';
import FindUs from '../components/FindUs';
import LoanPaymentSimulator from './LoanPaymentSimulator';

import { COUNTRY_TOP_LEVEL_DOMAIN } from '../constants';
import { getCarBodyTypes } from '../redux/actions/carActions';
import {
    resetNewCarsList,
    resetRecentCarsList,
    setNewCarListPage,
    setRecentCarListPage
} from '../redux/actions/carListAction';
import { getCustomerGallery } from '../redux/actions/customerGalleryActions';
import { fetchFeaturedCars } from '../redux/actions/fetchFeaturedCars';
import {
    fetchCheapestCarList,
    fetchNewCarList
} from '../redux/actions/fetchNewCarListAction';
import { ICombineReducerType } from '../redux/reducers';
import { SetMeta } from '../utils/Helper/jsHelpers';
import { getTopLevelDomain } from '../utils/translation';
import NeedHelp from '../components/NeedHelp';
import { fetchComingCars } from '../redux/actions/fetchComingCars';
import HelloPeterWidget from '../components/ui/HelloPeterWidget';

export const CAR_LIST_TYPE_ENUM = {
    electricCars: 'electricCars',
    importedCars: 'importedCars',
    newCars: 'newCars',
    cheapestCars: 'cheapestCars',
    fuelAndBodyType: 'fuelAndBodyType',
    custom: 'custom'
} as const;

export type ICarListType = keyof typeof CAR_LIST_TYPE_ENUM;

const Home = () => {
    const dispatch = useDispatch();
    const { featuredCars } = useSelector(
        (state: ICombineReducerType) => state.featuredCars
    );
    const { newCars, cheapestCars } = useSelector(
        (state: ICombineReducerType) => state.carListByType
    );
    const { incomingCars } = useSelector(
        (state: ICombineReducerType) => state.incomingCars
    );
    const topLevelDomain = getTopLevelDomain();
    const isCarAmigo = topLevelDomain === COUNTRY_TOP_LEVEL_DOMAIN.sn;

    useEffect(() => {
        // (async function () {
        getCustomerGallery(dispatch);
        fetchNewCarList(dispatch, { page: 1, limit: 6 });
        fetchFeaturedCars(dispatch, { page: 1, limit: 6 });
        fetchComingCars(dispatch, { page: 1, limit: 6 });
        fetchCheapestCarList(dispatch, getMaxPriceAccToCountry(), {
            page: 1,
            limit: 3,
            random: true
        });
        // Increase recently and new car listing page number by one
        setNewCarListPage(dispatch, 2);
        setRecentCarListPage(dispatch, 2);

        getCarBodyTypes(dispatch, true);
        // })();

        return () => {
            resetNewCarsList(dispatch);
            resetRecentCarsList(dispatch);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function getMaxPriceAccToCountry() {
        switch (topLevelDomain) {
            case COUNTRY_TOP_LEVEL_DOMAIN.bj:
                return 100000;
            case COUNTRY_TOP_LEVEL_DOMAIN.ci:
                return 8000000;
            case COUNTRY_TOP_LEVEL_DOMAIN.coke:
                return 100000;
            case COUNTRY_TOP_LEVEL_DOMAIN.coza:
                return 200000;
            case COUNTRY_TOP_LEVEL_DOMAIN.ma:
                return 100000;
            case COUNTRY_TOP_LEVEL_DOMAIN.rw:
                return 15000000;
            case COUNTRY_TOP_LEVEL_DOMAIN.sn:
                return 8000000;
            case COUNTRY_TOP_LEVEL_DOMAIN.tg:
                return 100000;
            case COUNTRY_TOP_LEVEL_DOMAIN.tz:
                return 100000;
            case COUNTRY_TOP_LEVEL_DOMAIN.ug:
                return 100000;
            default:
                return 100000;
        }
    }

    return (
        <>
            <SetMeta
                title="homePageTitle"
                desc="homePageDesc"
                keywords="homePageKeywords"
            />
            <div className="home">
                <Layout>
                    <Hero />
                    {/* Priortize Recently added cars section over New Cars section for MA */}
                    {
                        topLevelDomain !== COUNTRY_TOP_LEVEL_DOMAIN.ma ?
                        /* New Cars section */
                        <CarListByType
                            title="newCarList"
                            subtitle="newCarListSubtitle"
                            carData={newCars?.cars ?? []}
                            total={newCars.total ?? 0}
                            type={CAR_LIST_TYPE_ENUM.newCars}
                        /> :
                        <RecentlyAdded
                            title="recentlyAdded"
                            subtitle="recentlyAddedSubtitle"
                            carData={featuredCars.cars}
                            total={featuredCars.totalFeatured}
                        />
                    }
                    {topLevelDomain !== COUNTRY_TOP_LEVEL_DOMAIN.asterdio && //Not for dev server
                        topLevelDomain === COUNTRY_TOP_LEVEL_DOMAIN.ma && (
                            <LoanPaymentSimulator />
                        )}
                    {/* Cheapest Cars section */}
                    <CarListByType
                        title="cheapestCarList"
                        subtitle="cheapestCarListSubtitle"
                        carData={cheapestCars?.cars ?? []}
                        total={cheapestCars.total ?? 0}
                        type={CAR_LIST_TYPE_ENUM.cheapestCars}
                        maxPrice={getMaxPriceAccToCountry()}
                        // hideCountButton={true}
                    />
                    {
                        topLevelDomain !== COUNTRY_TOP_LEVEL_DOMAIN.ma ?
                        <RecentlyAdded
                            title="recentlyAdded"
                            subtitle="recentlyAddedSubtitle"
                            carData={featuredCars.cars}
                            total={featuredCars.totalFeatured}
                        />:
                        /* New Cars section */
                        <CarListByType
                            title="newCarList"
                            subtitle="newCarListSubtitle"
                            carData={newCars?.cars ?? []}
                            total={newCars.total ?? 0}
                            type={CAR_LIST_TYPE_ENUM.newCars}
                        />
                    }

                    {isCarAmigo && (
                        <RecentlyAdded
                            title="buyComingCars"
                            subtitle="comingCarsSubtitle"
                            carData={incomingCars.cars}
                            total={incomingCars.totalComing}
                            isIncomingCars={true}
                        />
                    )}

                    <SearchByCategory />

                    <ChooseAuto24 />

                    <Process
                        showProcessBackground
                        title="howItWorks"
                        showSwitch
                    />

                    {
                        topLevelDomain === COUNTRY_TOP_LEVEL_DOMAIN.coza ?
                        <HelloPeterWidget /> : null
                    }
                    <Promotions />

                    <Certification from="home" />

                    <Loan />

                    <Blog />

                    {/* <Location totalCars={featuredCars?.totalFeatured} /> */}
                    <FindUs />
                    <Service />
                    {/* <Questionnaire /> */}
                    <Press />
                    <InstaGram />
                    <FooterContent />
                    <NeedHelp />
                    <DownloadApp />
                    {topLevelDomain === COUNTRY_TOP_LEVEL_DOMAIN.asterdio && ( //Only for dev server
                        <FilteredCarModelsFooter />
                    )}
                </Layout>
            </div>
        </>
    );
};

export default Home;
